import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';


export default class RequestLogsForm {
  public type: string;
  public lines: number

  public rules: { [name: string]: FormValidationFunction[] } = {
    type: [
      (v: string) => !!v || 'Logs Type is required!',
      (v: string) => ['access', 'error'].includes(v) || 'Invalid logs type!',
    ],
    lines: [
      (v: number) => !!v || 'Logs Lines count is required!',
      (v: number) => [10, 20, 50].includes(v) || 'Invalid Lines count!',
    ],

  };
}
